<template>
  <div><!-- Component wrapper -->
    <!-- <div class="flex mx-auto items-center justify-center py-10 border-b-2 border-gamma-blue">

      <button @click="cart=cart-1" :disabled="cart==0" class="">
        <img v-if="cart==0" src="@/assets/images/alg.svg" class="mr-5">
        <img v-else src="@/assets/images/alb.svg" class="mr-5">
      </button>  

      <button @click="cart=0" class="flex items-center justify-center border-2 rounded-full w-10 h-10 mr-5"
      v-bind:class="[{'border-gamma-green bg-gamma-green':cart==0},{'border-gamma-blue':cart!=0}]">
        <span class="font-bold text-xl mt-1"
        v-bind:class="[{'text-white':cart==0},{'text-gamma-blue':cart!=0}]">
         1
        </span>
      </button>
      <button @click="cart=1" class="flex items-center justify-center border-2 rounded-full w-10 h-10 mr-5"
      v-bind:class="[{'border-gamma-green bg-gamma-green':cart==1},{'border-gamma-blue':cart!=1}]">
        <span class="font-bold text-xl mt-1"
        v-bind:class="[{'text-white':cart==1},{'text-gamma-blue':cart!=1}]">
         2
        </span>
      </button>
      <button @click="cart=2" class="flex items-center justify-center border-2 rounded-full w-10 h-10 mr-5"
      v-bind:class="[{'border-gamma-green bg-gamma-green':cart==2},{'border-gamma-blue':cart!=2}]">
        <span class="font-bold text-xl mt-1"
        v-bind:class="[{'text-white':cart==2},{'text-gamma-blue':cart!=2}]">
         3
        </span>
      </button>  

      <button @click="cart=cart+1" :disabled="cart==2" class="">
        <img v-if="cart==2" src="@/assets/images/arg.svg" class="">
        <img v-else src="@/assets/images/arb.svg" class="mr-5">
      </button> 

    </div> -->
    <div v-if="cart==0" class="flex flex-col items-center"><!--Main content-->
      
      <div class="w-full flex flex-col items-center mt-10 border-t border-gamma-blue" v-for="(offer,j) in offers" :key="j"><!-- PRODUCT TILE-->
        <h1 class="text-center mt-2"> Opslagruimte {{offer.short}} - {{offer.size}}m<sup>3</sup></h1>
         <h4 class="text-gamma-grayA mt-2">ca. {{offer.boxes}} verhuisdozen | {{offer.sizeSquare}} m<sup>2</sup> | maximaal {{offer.maxH}}m hoog</h4>
         <img v-bind:src="require(`@/assets/images/${offer.img}`)" class="w-40 h-40">

         <h2>€{{offer.price}} per maand</h2>
         <h4>v.a. gratis ophalen& bezorgen</h4>
         <button @click="selectSize(offer.size); cart=1" class="w-[180px] flex items-center bg-gamma-green rounded-2xl py-2 px-4 hover:shadow-2xl mt-5">
            
            <p class="text-white mx-auto">Meer informatie</p>

         </button>
         <div class="w-[180px] flex items-center bg-gamma-gray border border-gamma-blue rounded-xl p-2 mt-5">
                    <img src="@/assets/images/avatar.png" class=" w-6 h-6 mr-2">
                    <span class=" text-xs text-gamma-blue"><a href="https://meetings.hubspot.com/bram-meeting-link/gamma-opslagservice" target="_blank"> Hulp nodig met kiezen?</a></span>
                </div>    
        

      </div><!-- END PRODUCT TILE-->  

      

    </div><!--END Main content-->
    <div v-if="cart==1" class="w-full flex flex-col items-center mt-10"><!--Main content-->
      <h1>{{currentOffer.size}}m<sup>3</sup> ({{currentOffer.type}}) </h1>
      <div class="flex">
        <div class="mr-5">
          <img v-bind:src="require(`@/assets/images/${currentOffer.img}`)" class="w-40 h-40 mr-5">
        </div>
        <div class="flex flex-col">
          <div class="flex items-center justify-between mt-5">
            <h1>€{{calculateDiscountPrice(currentOffer.price,selectedCommitment)}} </h1>
            <p class="text-xs italic">per maand</p>
          </div> 
          <div class="flex items-center justify-between mt-5">
            <h2 v-if="submitData.plan=='Doe het zelf - basic service'">€{{travelTotal}} </h2>
            <h2 v-else>€{{currentOffer.premium*1 + travelTotal*1}} </h2>
            <p class="text-xs italic">eenmalig</p>
          </div>
         
          
        </div>  
      
      </div>  
      <div class="flex">
          <button @click="spanDetails=true" class="flex items-center border-2 border-gamma-blue p-2 rounded-xl mt-5 mr-5">
            <img src="@/assets/images/info.svg" class="mr-2">
            <p class="">Bekijk details</p>
          </button>
          <button @click="spanHIW=true" class="flex items-center border-2 border-gamma-blue p-2 rounded-xl mt-5">
            <img src="@/assets/images/info.svg" class="mr-2">
            <p class="">Hoe werk het</p>
          </button>
          </div>
      <h3 class="mt-5">Bekijk andere opslagruimten:</h3>
      <div class="flex mt-5">
        <button v-for="(offer,k) in offers" :key="k"
          @click="selectSize(offer.size)"
          class="border border-gamma-blue px-2 mr-5"
          v-bind:class="{'border-gamma-green bg-gamma-green':selectedSize==offer.size}">
          <p v-bind:class="[{'text-white':selectedSize==offer.size},{'font-bold text-gamma-blue':selectedSize!=offer.size}]">
            {{offer.short}}
          </p>
        </button>
      </div>
      <h3 class="mt-5">Minimale huurperiode:</h3>
      <div class="flex mt-2 mb-5">
        <button @click="selectCommitment(1)" class="border border-gamma-blue px-2 mr-5"
          v-bind:class="{'bg-gamma-green':selectedCommitment==1}">
          <p v-bind:class="[{' font-bold text-white':selectedCommitment==1},{'font-bold text-gamma-blue':selectedCommitment!=1}]">1+</p>
        </button>
        <button @click="selectCommitment(3)" class="border border-gamma-blue px-2 mr-5"
          v-bind:class="{'bg-gamma-green':selectedCommitment==3}">
          <p v-bind:class="[{' font-bold text-white':selectedCommitment==3},{'font-bold text-gamma-blue':selectedCommitment!=3}]">3+</p>
        </button>
        <button @click="selectCommitment(6)" class="border border-gamma-blue px-2 mr-5"
          v-bind:class="{'bg-gamma-green':selectedCommitment==6}">
          <p v-bind:class="[{' font-bold text-white':selectedCommitment==6},{'font-bold text-gamma-blue':selectedCommitment!=6}]">6+</p>
        </button>
        <button @click="selectCommitment(12)" class="border border-gamma-blue px-2 mr-5"
          v-bind:class="{'bg-gamma-green':selectedCommitment==12}">
          <p v-bind:class="[{' font-bold text-white':selectedCommitment==12},{'font-bold text-gamma-blue':selectedCommitment!=12}]">12+</p>
        </button>
      </div>
      <h3 class="mt-5">In welke regio staan de spullen?</h3>
      <select v-model="travelCost" @change="changeTravelCosts()" class="inpt mt-2 ">  
        <option v-for="(tc,i) in travelCosts" :key="i" :value="i">{{tc.name}}</option>
      </select>
      <h3 class="mt-5">Kies ophaalservice:</h3>
      <div class="flex items-center justify-center mt-5">
        <select v-model="plan" @change="selectPack(plan)" class="inpt mr-2">  
          <option  value="Doe het zelf - basic service">Doe het zelf service (basis)</option>
          <option  value="Do it for you - permium service">Do it for you service (premium)</option>
        </select>
        <button @click="spanTable=true">
        <img src="@/assets/images/help-circle.svg" class="mr-2">
        </button>
      </div>  
      
      <div class="bg-gamma-green border-2 border-white rounded-3xl flex justify-center p-2 mt-5 hover:shadow-2xl">      
        <button @click="cart=2"><p class="text-white md:text-sm lg:text-lg mt-1 ">In Winkelwagen</p></button>
      </div>
      <div v-if="spanDetails" class="overlay">
        <button class="absolute right-5 mt-10 " @click="spanDetails=false">
          <img src="@/assets/images/close-span.svg" class="">          
        </button>
        <div class="flex flex-col items-center mt-10">
            <h3>Details:</h3>
            <p>Vierkante meter: ca {{currentOffer.sizeSquare}}</p>
            <p>Aantal verhuisdozen: ca {{currentOffer.boxes}}</p>
            <p>Aantal rolcontainers: ca {{currentOffer.containers}}</p>
            <p>Maximale hoogte: {{currentOffer.maxH}}m</p>
            <p>Max.lengte/breedte: ca {{currentOffer.maxL}}m</p>
        </div>   
        <div class="flex flex-col items-center mt-10 ">
            <h3>Gamma opslagservice:</h3>
            <div class="w-max flex mt-1 pl-5">
              <img src="@/assets/images/gamma-check.svg" class="mr-1">
              <span class="chSPES">Huren vanaf 1 maand</span>
            </div>
            <div class="w-max flex mt-3 pl-5">
              <img src="@/assets/images/gamma-check.svg" class="mr-1">
              <span class="chSPES">Altijd bij jou ophalen</span>
            </div>
            <div class="w-max flex mt-3 pl-5">
              <img src="@/assets/images/gamma-check.svg" class="mr-1">
              <span class="chSPES">Overal in Nederland bezorgen</span>
            </div>
             <div class="w-max flex mt-3 pl-5">
              <img src="@/assets/images/gamma-check.svg" class="mr-1">
              <span class="chSPES">Van doe het zelf tot"do it for you"</span>
            </div>
        </div>   
        <div class="flex items-center bg-gamma-gray border border-gamma-blue rounded-xl w-[250px] mx-auto p-4 mt-10">
            <img src="@/assets/images/avatar.png" class=" w-6 h-6 mr-5">
            <span class="text-gamma-blue"><a href="https://meetings.hubspot.com/bram-meeting-link/gamma-opslagservice" target="_blank"> Hulp nodig met kiezen?</a></span>
          </div>   

      </div>  
      <div v-if="spanTable" class="overlay flex flex-col items-center">
        <button class="absolute right-5 top-5 " @click="spanTable=false">
          <img src="@/assets/images/close-span.svg" class="">
          
        </button>
        
      
        <div class="flex mt-10 ">
          <div class="flex flex-col w-1/3 mr-5">
            <div class="h-10 border-t border-gamma-gray">
                
            </div>
            <div class="h-10 flex items-center justify-center border-t border-black">
                <h4 class="font-bold">CHAUFFEUR</h4>
            </div>   
            <div class="h-10 flex items-center justify-center border-t border-black">
                <h4 class="font-bold">SJOUWHULP</h4>
            </div>  
            <div class="h-10 flex items-center justify-center border-t border-black">
                <h4 class="font-bold">UNITS INDELEN</h4>
            </div>
            <div class="h-10 flex items-center justify-center border-t border-black">
                <h4 class="font-bold text-xs">BESCHERMINGSPAKKET</h4>
            </div>
            <div class="h-10 flex items-center justify-center border-t border-black">
                <h4 class="font-bold text-xs">PROFESSIONEEL VERVOER</h4>
            </div>
            <div class="h-10 flex items-center justify-center border-t border-black">
                <h4 class="font-bold text-xs">OPSLAGUNITS VERVOEREN</h4>
            </div>
            <div class="h-10 flex items-center justify-center border-t border-black">
                <h4 class="font-bold">PRIJS</h4>
            </div>
            <div class=" flex items-center justify-center border-t border-black">
                <p class="mt-3 pl-4 text-xs italic">*VANAF PRIJS O.A. AFHANKELIJK LOOPTIJD EN LOCATIE</p>
            </div>
          </div>
          <div class="flex flex-col w-1/3" v-bind:class="{'bg-gamma-gray':plan=='Doe het zelf - basic service'}">
            <div class="h-10 flex items-center justify-center border-t border-gamma-gray">
                <p class="text-gamma-blue p-2">"Doe het zelf"-service</p>
            </div>
            <div class="h-10 flex items-center justify-center border-t border-black">
                <img src="@/assets/images/jaa.svg" class="mr-1">
            </div>   
            <div class="h-10 flex items-center justify-center border-t border-black">
                <img src="@/assets/images/nee.svg" class="mr-1">
            </div> 
            <div class="h-10 flex items-center justify-center border-t border-black">
                <img src="@/assets/images/jaa.svg" class="mr-1">
            </div>  
            <div class="h-10 flex items-center justify-center border-t border-black">
                <img src="@/assets/images/jaa.svg" class="mr-1">
            </div>  
            <div class="h-10 flex items-center justify-center border-t border-black">
                <img src="@/assets/images/jaa.svg" class="mr-1">
            </div>  
            <div class="h-10 flex items-center justify-center border-t border-black">
                <img src="@/assets/images/jaa.svg" class="mr-1">
            </div>  
            <div class="h-10 flex items-center justify-center border-t border-black">
                <h4 class="font-bold">GRATIS*</h4>
            </div>   
          </div>
          <div class="flex flex-col w-1/3" v-bind:class="{'bg-gamma-gray':plan=='Do it for you - permium service'}">
            <div class="h-10 flex items-center justify-center border-t border-gamma-gray">
                <p class="text-gamma-blue p-2">"Do it for you"- service</p>
            </div>
            <div class="h-10 flex items-center justify-center border-t border-black">
                <img src="@/assets/images/jaa.svg" class="mr-1">
            </div>   
            <div class="h-10 flex items-center justify-center border-t border-black">
                <img src="@/assets/images/jaa.svg" class="mr-1">
            </div>  
            <div class="h-10 flex items-center justify-center border-t border-black">
                <img src="@/assets/images/jaa.svg" class="mr-1">
            </div>
            <div class="h-10 flex items-center justify-center border-t border-black">
                <img src="@/assets/images/jaa.svg" class="mr-1">
            </div>
            <div class="h-10 flex items-center justify-center border-t border-black">
                <img src="@/assets/images/jaa.svg" class="mr-1">
            </div>
            <div class="h-10 flex items-center justify-center border-t border-black">
                <img src="@/assets/images/jaa.svg" class="mr-1">
            </div>
            <div class="h-10 flex items-center justify-center border-t border-black">
                <h4 class="font-bold">MEEPRIJS*</h4>
            </div>
          </div>
       </div>
       <div class="mt-10">
       <select v-model="plan" @change="selectPack(plan)" class="inpt">  
          <option  value="Doe het zelf - basic service">Doe het zelf service (basis)</option>
          <option  value="Do it for you - permium service">Do it for you service (premium)</option>
        </select>
        </div>

       
          
      </div> 
      <div v-if="spanHIW" class="overscroll">
        <button class="absolute right-5 top-5 " @click="spanHIW=false">
          <img src="@/assets/images/close-span.svg" class="">
          
        </button>
        <div class="flex flex-col items-center mt-10 mb-10"><!-- Service plans -->  
       <h1>Hoe werk het</h1>
       
      <div class="flex flex-col items-center">
        <img src="@/assets/images/calculate-gamma.svg" class="w-32 h-32">
        <h3 class="font-bold text-center mt-5">Bepaal je opslagruimte</h3>
        <div class="flex flex-col items-start">
          <div class="flex items-center mt-2">
            <img src="@/assets/images/gamma-check.svg" class="mr-2">
            <p class="text-xs">Kies zelf wat je nodig hebt</p>
          </div>
          <div class="flex items-center mt-1">
            <img src="@/assets/images/gamma-check.svg" class="mr-2">
            <p class="text-xs">Laat ons je helpen!</p>
          </div>   
        </div>
      </div>
      <div class="flex flex-col items-center">
        <img src="@/assets/images/calendar-gamma.svg" class="w-32 h-32">
        <h3 class="font-bold text-center mt-5">Maak een ophaalafspraak</h3>
        <div class="flex flex-col items-start">
          <div class="flex items-center mt-2">
            <img src="@/assets/images/gamma-check.svg" class="mr-2">
            <p class="text-xs">Overal in Nederland</p>
          </div>
          <div class="flex items-center mt-1">
            <img src="@/assets/images/gamma-check.svg" class="mr-2">
            <p class="text-xs">Met of zonder</p>
          </div> 
        </div>  
      </div>
      <div class="flex flex-col items-center">
        <img src="@/assets/images/truck-gamma.svg" class="w-32 h-32">
        <h3 class="font-bold text-center mt-5">Je spullen in-& verpakt klaarzetten</h3>
        <div class="flex flex-col items-start">
          <div class="flex items-center mt-2">
            <img src="@/assets/images/gamma-check.svg" class="mr-2">
            <p class="text-xs">Doe zelf het sjouwwerk</p>
          </div>
          <div class="flex items-center mt-1">
            <img src="@/assets/images/gamma-check.svg" class="mr-2">
            <p class="text-xs">Of laat ons het voor je doen</p>
          </div>   
        </div>
      </div>
      <div class="flex flex-col items-center">
        <img src="@/assets/images/stuff-gamma.svg" class="w-32 h-32">
        <h3 class="font-bold text-center mt-5">Thuisbezorgen als het nodig hebt</h3>
        <div class="flex flex-col items-start mb-10">
          <div class="flex items-center mt-2">
            <img src="@/assets/images/gamma-check.svg" class="mr-2">
            <p class="text-xs">In heel Nederland bezorgd</p>
          </div>
          <div class="flex items-center mt-1">
            <img src="@/assets/images/gamma-check.svg" class="mr-2">
            <p class="text-xs">Van doe het zelf tot do it for you</p>
          </div>
        </div>   
      </div>  
      
      </div> 
      </div>   
      
      
      <!--<div class="flex flex-col w-1/2 mt-5 mb-40"> Service plans  
       <h1>Meest gestelde vragen</h1>
       <div class="flex items-start justify-between border-t border-gamma-grayA mt-4 p-4"
         v-bind:class="{'h-40':faqOne==true}">
         <h3 class="text-gamma-blue">Waar zijn de opslaglocaties?</h3>
         <button @click="faqOne=!faqOne">
            <img v-if="!faqOne" src="@/assets/images/dropArrowGamma.svg" class="mr-2">
            <img v-else src="@/assets/images/hideArrowGamma.svg" class="mr-2">
         </button>
       </div>  
       <div class="flex items-start justify-between border-t border-gamma-grayA mt-4 p-4"
         v-bind:class="{'h-40':faqTwo==true}">
         <h3 class="text-gamma-blue">Hoe zijn mijn spullen beveiligd?</h3>
         <button @click="faqTwo=!faqTwo">
            <img v-if="!faqTwo" src="@/assets/images/dropArrowGamma.svg" class="mr-2">
            <img v-else src="@/assets/images/hideArrowGamma.svg" class="mr-2">
         </button>
       </div>
       <div class="flex items-start justify-between border-t border-gamma-grayA mt-4 p-4"
         v-bind:class="{'h-40':faqThree==true}">
         <h3 class="text-gamma-blue">Hoe zit het met meer of minder kosten?</h3>
         <button @click="faqThree=!faqThree">
            <img v-if="!faqThree" src="@/assets/images/dropArrowGamma.svg" class="mr-2">
            <img v-else src="@/assets/images/hideArrowGamma.svg" class="mr-2">
         </button>
       </div>   
       <div class="flex items-start justify-between border-t border-gamma-grayA mt-4 p-4"
         v-bind:class="{'h-40':faqFour==true}">
         <h3 class="text-gamma-blue">Zijn mijn spullen verzekerd?</h3>
         <button @click="faqFour=!faqFour">
            <img v-if="!faqFour" src="@/assets/images/dropArrowGamma.svg" class="mr-2">
            <img v-else src="@/assets/images/hideArrowGamma.svg" class="mr-2">
         </button>
       </div>   
       <div class="flex items-start justify-between border-t border-gamma-grayA mt-4 p-4"
         v-bind:class="{'h-40':faqFive==true}">
         <h3 class="text-gamma-blue">Hoe bereid ik mijn afspraak zo goed mogelijk voor?</h3>
         <button @click="faqFive=!faqFive">
            <img v-if="!faqFive" src="@/assets/images/dropArrowGamma.svg" class="mr-2">
            <img v-else src="@/assets/images/hideArrowGamma.svg" class="mr-2">
         </button>
       </div>
       <div class="flex items-start justify-between border-t border-gamma-grayA mt-4 p-4"
         v-bind:class="{'h-40':faqSix==true}">
         <h3 class="text-gamma-blue">Kan ik tussentijds bij mijn spullen?</h3>
         <button @click="faqSix=!faqSix">
            <img v-if="!faqSix" src="@/assets/images/dropArrowGamma.svg" class="mr-2">
            <img v-else src="@/assets/images/hideArrowGamma.svg" class="mr-2">
         </button>
       </div> 
       <div class="flex items-start justify-between border-t border-gamma-grayA mt-4 p-4"
         v-bind:class="{'h-40':faqSeven==true}">
         <h3 class="text-gamma-blue">Waarom de opslagservice van GAMMA?</h3>
         <button @click="faqSeven=!faqSeven">
            <img v-if="!faqSeven" src="@/assets/images/dropArrowGamma.svg" class="mr-2">
            <img v-else src="@/assets/images/hideArrowGamma.svg" class="mr-2">
         </button>
       </div>          

      </div> --> 

    
        

      

    </div><!--END Main content-->
    <div v-if="cart==2" class="flex flex-col w-full mx-auto   border rounded-lg border-checkout-mainborder mt-16 overflow-hidden"><!-- QUOTE BOX-->
        <h2 class="chH2 m-6">Overzicht</h2>
        <div class="flex justify-between py-5 px-6 border-t border-checkout-mainborder"><!-- SINGLE QUOTE SECTION-->
          <div class="flex"><!-- NAME AND ICON -->
            <img src="@/assets/images/opslag-gamma.svg" class="mr-5">
            <span class="chSpan">Opslagruimte</span>
          </div><!--END NAME AND ICON -->
          <div class="flex"><!-- VALUE AND CHANGE BUTTON -->
            <span class="chSpan mr-1">{{submitData.storage_size}} m<sup>3</sup></span>
            
          </div><!--END VALUE AND CHANGE BUTTON --> 

        </div><!-- END SINGLE QUOTE SECTION-->   

        <div class="flex justify-between py-5 px-6 border-t border-checkout-mainborder"><!-- SINGLE QUOTE SECTION-->
          <div class="flex"><!-- NAME AND ICON -->
            <img src="@/assets/images/commitment-gamma.svg" class="mr-5">
            <span class="chSpan">Huurperiode</span>
          </div><!--END NAME AND ICON -->
          <div class="flex flex-col items-end"><!-- VALUE AND CHANGE BUTTON -->
            <span class="chSpan mr-1">{{getCommitmentTitle(submitData.commitment)}}</span>
            <p class="text-xs italic">daarna per gehele maand verlengd</p>
            
          </div><!--END VALUE AND CHANGE BUTTON --> 

        </div><!-- END SINGLE QUOTE SECTION-->

         

        <div class="flex justify-between py-5 px-6  border-t border-checkout-mainborder"><!-- SINGLE QUOTE SECTION-->
          <div class="flex"><!-- NAME AND ICON -->
            <img src="@/assets/images/small-truck-gamma.svg" class="mr-5">
            <span class="chSpan">Servicepakket</span>
          </div><!--END NAME AND ICON -->
          <div class="flex flex-col items-center"><!-- VALUE AND CHANGE BUTTON -->
            <span class="chSpan mr-1">{{getPlan()}}</span>
            
            
          </div><!--END VALUE AND CHANGE BUTTON --> 

        </div><!-- END SINGLE QUOTE SECTION-->

        

          

           

        <div class="flex justify-between py-5 px-6 bg-checkout-light border-t border-checkout-pborder"><!-- PER MONTH PRICE SECTION-->
          <div class="flex"><!-- NAME AND ICON -->
            <img src="@/assets/images/repeat.svg" class="mr-5">
            <span class="chStrongSpan">Maandelijks</span>
          </div><!--END NAME AND ICON -->
          <div class="flex"><!-- VALUE AND CHANGE BUTTON -->
            <span class="chStrongSpan mr-1">€{{calculateDiscount(submitData.commitment)}},00</span>
            
          </div><!--END VALUE AND CHANGE BUTTON --> 

        </div><!-- END PER MONTH PRICE-->   

        <div class="flex justify-between py-5 px-6 bg-checkout-light border-t border-checkout-pborder"><!-- TOTAL PRICE SECTION-->
          <div class="flex"><!-- NAME AND ICON -->
            <img src="@/assets/images/shopping-bag.svg" class="mr-5">
            <span class="chStrongSpan">Eenmalig</span>
          </div><!--END NAME AND ICON -->
          <div class="flex"><!-- VALUE AND CHANGE BUTTON -->
            <span class="chStrongSpan mr-1">€ {{getPlanPrice()*1 + travelTotal*1}}</span>
            
          </div><!--END VALUE AND CHANGE BUTTON --> 

        </div><!-- END TOTAL PRICE-->       
      
    </div><!-- END QUOTE BOX--> 
    

    
      
      <div v-if="cart==2" class="flex flex-col w-full mx-auto mt-16">          
        
        <div class="flex flex-col items-start border border-checkout-mainborder rounded-lg overflow-hidden"><!--DATE BOX-->
          <h3 class="mt-8 pl-8">Kies voorkeursdatum</h3>
          
            <div class="flex flex-col mt-6 pl-8 pr-4 w-full"><!-- date input -->
              <p class="text-sm font-bold">Kies je ophaaldatum</p>
              <input type="date" v-model="pickupDate" class="inpt" />          
            </div><!-- END date input -->

            

            <div class="w-full flex flex-col justify-center mt-2 h-24 pl-8 pr-4">
                <p class="text-sm font-bold">Voorkeursmoment</p>
                <select v-model="prefMoment" class="inpt">
                  <option value="0">Dagplanning 08:00 - 19:00 (gratis)</option>
                  <option value="1">Ochtendvak 08:00 - 12:00 (+ € 20)</option>
                  <option value="2">Middagvak 12:00 - 16:00 (+ € 20)</option>
                  <option value="3">DagStart 08:00 - 10:00 (+ € 35)</option>
                  <option value="4">Weekend (+ € 50)</option>
                </select>
              </div>
            <p class="text-xs italic pl-8">* deze datum wordt na je boeking pas definitief bevestigd</p>  
          
          

          <div class="border-t border-checkout-pborder bg-checkout-light px-6 mt-6 pb-5 w-full"><!-- bottom box -->
            <p class="mt-4">De gereserveerde ophaaldatum</p>
            <p class="mt-2">{{getDayName(pickupDate,"nl-NL")}} {{getDay(pickupDate)}} {{getMonthName(pickupDate,"nl-NL")}} {{getPrefTime(prefMoment)}}</p>

          </div><!--END bottom box -->          
        </div><!--END DATE BOX-->
        <!--<div class="flex flex-col items-start mt-4 mr-8 border border-checkout-mainborder rounded-lg overflow-hidden">DATE BOX
          <h3 class="mt-8 pl-8">Zakelijk huren?</h3>
          <p class="mt-2 pl-8">Vul je bedrijfsnaam in</p>
          <div class="flex  mt-6 pl-8 pr-4 w-full">
            
            
            <input v-model="klantBox" type="checkbox" @change="changeKlant()" class="mr-1.5">
            <span class="chL">Zakelijke klant</span>  
            
          </div>  

          <div class="flex flex-col justify-center mt-2 h-24 pl-8 mb-3">
            <p class="text-sm font-bold">Bedrijfsnaam</p>
            <input ref="zip" v-model="companyName" :disabled="klantType=='b2c'" v-bind:class="[{ 'inpt': !companyNameError }, {'inptError': companyNameError }]">
            <p class="absolute text-sm text-gamma-error md:w-40 lg:w-64 mt-24 p-1" v-if="companyNameError"><br><br>{{companyNameError}}</p>
          </div>  
               
        </div>END name input -->
      </div> 
    <div v-if="cart==2" class="flex flex-col items-center border border-checkout-mainborder rounded-lg overflow-hidden w-full mx-auto pb-16 mt-16" id="111">
    <h3 class="mt-8 pl-8">Vul je gegevens in.</h3>
        
        <div class="flex">
          <div class="flex flex-col justify-center mr-5">
          <p class="text-sm font-bold">Voornaam</p>
          <input v-model="fullName" v-bind:class="[{ 'inpt w-[180px] ': !nameError }, {'inptError w-[180px]': nameError }]">
          <div class="h-10">  
            <p class="text-sm text-gamma-error -mt-4 p-1" v-if="nameError"><br>{{nameError}}</p>
          </div>
        </div>

        <div class="flex flex-col justify-center ">
          <p class="text-sm font-bold">Achternaam</p>
          <input v-model="lname" v-bind:class="[{ 'inpt w-[180px]': !lnameError }, {'inptError w-[180px]': lnameError }]">
          <div class="h-10">  
            <p class="text-sm text-gamma-error -mt-4 p-1" v-if="lnameError"><br>{{lnameError}}</p>
          </div>
        </div>
        </div>

        <div class="flex">
          <div class="flex flex-col justify-center mr-5">
          <p class="text-sm font-bold">Postcode</p>
          <input ref="zip" v-model="zip" :readonly="$store.state.quotes.length>0" v-bind:class="[{ 'inpt w-[180px] ': !zipError }, {'inptError w-[180px]': zipError }]">
          <div class="h-10">
            <p class="text-sm text-gamma-error -mt-4 p-1" v-if="zipError"><br>{{zipError}}</p>
          </div>
        </div>


        <div class="flex flex-col justify-center ">
          <p class="text-sm font-bold">Stad</p>
          <input  v-model="city" :readonly="$store.state.quotes.length>0" v-bind:class="[{ 'inpt w-[180px]': !cityError }, {'inptError w-[180px]': cityError }]">
          <div class="h-10">
            <p class="text-sm text-gamma-error -mt-4 p-1" v-if="cityError"><br>{{cityError}}</p>
          </div>  
        </div>

        </div>  
        

        <div class="flex">
          <div class="flex flex-col justify-center mr-5">
          <p class="text-sm font-bold">Ophaaladres</p>
          <input v-model="address" v-bind:class="[{ 'inpt w-[180px]': !ophalError }, {'inptError w-[180px]': ophalError }]">
          <div class="h-10">
            <p class="text-sm text-gamma-error -mt-4 p-1" v-if="ophalError"><br>{{ophalError}}</p>
          </div>
        </div>

        <div class="flex flex-col justify-center">
          <p class="text-sm font-bold">Telefoonnummer</p>
          <input v-model="phone" v-bind:class="[{ 'inpt w-[180px]': !phoneError }, {'inptError w-[180px]': phoneError }]">
          <div class="h-10">
            <p class="text-sm text-gamma-error -mt-4 p-1" v-if="phoneError"><br>{{phoneError}}</p>
          </div>
        </div>
        </div>
        

          

        

          <div class="flex flex-col justify-center">
          <p class="text-sm font-bold">E-mailadres</p>
          <input v-model="email" v-bind:class="[{ 'inpt w-[380px] ': !emailError }, {'inptError w-[380px]': emailError }]">
          <div class="h-10">
           <p class="text-sm text-gamma-error -mt-4 p-1" v-if="emailError"><br>{{emailError}}</p>
          </div> 
        </div>
        

          

        

        

       
        
        
       
    </div> 
    <div v-if="cart==2" class="w-full flex flex-col mt-16 border border-checkout-mainborder rounded-lg mx-auto"><!--SINGLE SP BOX-->
       <div class="flex justify-between items-center py-5">
          <div class="flex items-center">
              <h3 class="chKies mr-2 ml-2">Meer informatie:</h3>
          </div>
          <button v-if="spanSPone" @click="spanSPone=false" class="p-2"><img src="@/assets/images/hideArrowGamma.svg" class=""></button>
          <button v-else @click="spanSPone=true" class="p-2"><img src="@/assets/images/dropArrowGamma.svg" class=""></button>
          
        </div>   
        <div class="flex flex-col border-t bg-checkout-mainbg border-checkout-mainborder p-2"><!-- Span section -->
          <div v-if="spanSPone" class="flex items-start mt-2">
            <img src="@/assets/images/gamma-check.svg" class="py-2 mr-1">
            <p class="mt-1">
              Je maakt de reservering compleet en ontvangt de eerste factuur.
            </p>  
          </div>
          <div v-if="spanSPone" class="flex items-start mt-2">
            <img src="@/assets/images/gamma-check.svg" class="py-2 mr-1">
            <p class="mt-1">
             Na betaling kun je de voorkeursdatum voor de ophaalafspraak via de uitnodiging bevestigen.
            </p>  
          </div>
          <div v-if="spanSPone" class="flex items-start mt-2">
            <img src="@/assets/images/gamma-check.svg" class="py-2 mr-1">
            <p class="mt-1">
             Een dag voor ophaalafspraak ontvang je om uiterlijk 19:00 een ETA mail. Op de dag zelf belt de chauffeur vlak voor aankomst nog.
            </p>  
          </div>
          <div v-if="spanSPone" class="flex items-start mt-2">
            <img src="@/assets/images/gamma-check.svg" class="py-2 mr-1">
            <p class="mt-1">
             We halen je spullen volgens de gedane boeking op. Zijn het iets meer spullen dan proberen we het mee te nemen. Blijkt het toch minder te zijn dan kun je een downgrade verzoek doen.
            </p>  
          </div>
          <div v-if="spanSPone" class="flex items-start mt-2">
            <img src="@/assets/images/gamma-check.svg" class="py-2 mr-1">
            <p class="mt-1">
             Bij de ophaal afspraak voegen we een basisbeschermingspakket toe, laden je spullen efficiënt in de opslagunits en maken de opslagunits vervoer klaar.
            </p>  
          </div>
          <div v-if="spanSPone" class="flex items-start mt-2">
            <img src="@/assets/images/gamma-check.svg" class="py-2 mr-1">
            <p class="mt-1">
             We vervoeren de opslagunits professioneel en slaan ze geconditioneerd op totdat jij ze weer nodig hebt.
            </p>  
          </div>
          <div v-if="spanSPone" class="flex items-start mt-2">
            <img src="@/assets/images/gamma-check.svg" class="py-2 mr-1">
            <p class="mt-1">
             Wil je je spullen weer terug ontvangen? Stuur een mail naar klantenservice@inboxstorage.eu, ontvang een uitnodiging en plan je terugbrengafsrpaak zelf in; simpel!
            </p>  
          </div>

          <div class="flex flex-col w-full mt-4 p-2 border border-checkout-mainborder rounded-lg"
            v-bind:class="{'bg-checkout-light border-checkout-primary':agreeOne}"><!--SINGLE ES BOX-->
            <div class="flex justify-between items-center py-[24px]">
                <div class="flex items-center">
                    <div class="flex items-center ">
                      <button @click="agreeOne=!agreeOne" class="w-5 h-5  mr-2">
                        <img v-if="agreeOne" src="@/assets/images/check-square.svg" class="w-5 h-5">
                        <img v-else src="@/assets/images/square.svg" class="w-5 h-5">
                      </button>
                    </div>              
                    <h3 class="text-xs">Ik accepteer de 
                      <span class="border-b border-gamma-blue text-xs">
                        <a href="https://inboxstorage.eu/pdf/Algemene-Voorwaarden-Inboxstorage-v1.pdf" target="_blank">algemene voorwaarden</a>
                      </span>
                    </h3>
                </div>
                
              </div>        
          </div><!--END SINGLE ES BOX-->
          <div class="flex flex-col w-full mt-4 p-2 border border-checkout-mainborder rounded-lg"
            v-bind:class="{'bg-checkout-light border-checkout-primary':agreeTwo}"><!--SINGLE ES BOX-->
            <div class="flex justify-between items-center py-[24px]">
                <div class="flex items-center">
                    <div class="flex items-center ">
                      <button @click="agreeTwo=!agreeTwo" class="w-5 h-5 mr-2">
                        <img v-if="agreeTwo" src="@/assets/images/check-square.svg" class="w-5 h-5">
                        <img v-else src="@/assets/images/square.svg" class="w-5 h-5">
                      </button>
                    </div>              
                    <h3 class="text-xs">Ik in - en verpak mijn spullen volgens de 
                      <span class="border-b border-gamma-blue text-xs">
                        <a href="https://inboxstorage.eu/pdf/Inpak-instructies-2.3.pdf" target="_blank">inpakinstructies</a>
                      </span>
                    </h3>
                </div>
                
              </div>        
          </div><!--END SINGLE ES BOX-->
          <div  id="1" class="flex flex-col w-full  mt-4 p-2 border border-checkout-mainborder rounded-lg mb-2"
            v-bind:class="{'bg-checkout-light border-checkout-primary':agreeThree}"><!--SINGLE ES BOX-->
            <div class="flex justify-between items-center py-[24px]">
                <div class="flex items-center">
                    <div class="flex items-center">
                      <button @click="agreeThree=!agreeThree" class="w-5 h-5 mr-2">
                        <img v-if="agreeThree" src="@/assets/images/check-square.svg" class="w-5 h-5">
                        <img v-else src="@/assets/images/square.svg" class="w-5 h-5">
                      </button>
                    </div>              
                    <h3 class="text-xs">Annuleren van de boeking is 48 uur na de boeking kosteloos. Daarna is het herroepingsrecht niet van toepassing.</h3>
                </div>
                
              </div> 
             
          </div><!--END SINGLE ES BOX-->
          
          <div v-if="finError" class="pl-[32px] text-red-500">
          {{finError}}
        </div>
            


        </div><!-- END span section -->    
    
      </div><!--END SINGLE SP BOX-->  
       <div v-if="cart==2" class="bg-gamma-green border-2 border-white rounded-3xl flex justify-center py-2 mt-6 w-1/2 mx-auto mb-10">
      
      <button @click="submit()"><p class="text-white md:text-sm lg:text-lg mt-1">Reservering bevestigen</p></button>
    </div> 
    <div v-if="cart==3" class="w-full flex items-center justify-center bg-gamma-gray p-4 mx-auto">
      <p class="text-xl">Thank you for your order. To confirm the booking please visit <a :href="mollieLink" class="border-b border-gamma-blue" target="_blank">this link</a></p>
    </div>
    
    
</div><!-- Component wrapper -->    
</template>
<script>
import axios from 'axios'
import {mapState, mapMutations} from 'vuex'
export default {
  name: 'New',  
  components: {  
  },
  data() {
    return {
      errors: [],
      cart: 0,
      travelCost: 0,

      plan: 'Doe het zelf - basic service',
      animation: false,
      phoneCode: '+31',
  
      spanSPone: false,
      spanSPtwo: false,
      spanSPthree: false,
      checkSPone:false,
      checkSPtwo: false,
      checkSPthree:false,

      totalES: 0,
      spanES: false,
      totalESPrice: 0,

      spanDriverHelp:false,
      checkDriverHelp:false,

      spanPakMaterial:false,
      checkPakMaterial:false,

      spanVerpakHulp:false,
      checkVerpakHulp:false,

      spanDemontage:false,
      checkDemontage:false,

      spanVerhuislift:false,
      checkVerhuislift:false,

      spanTussenStop:false,
      checkTussenStop:false,

      spanFilter:false,

      selectedCommitment: '12',
      selectedSize: '24',

      prefMoment: 0,
      pickupDate: '',

      klantBox: false,
      klantType: 'b2c',

      companyName: '',

      address: '',
      zip: '',
      fullName: '',
      lname: '',
      lnameError: '',
      email: '',
      phone: '',
      city: '',

      nameError: '',
      lnameError: '',
      emailError: '',
      phoneError: '',
      ophalError: '',
      zipError: '',
      cityError: '',

      link: '',
      finError: '',
      travel: '',
      refreshedOnce: false,

      travelTotal: 0,
      agreeOne: false,
      agreeTwo: false,
      agreeThree: false,

      spanDetails: false,
      spanTable: false,
      spanHIW: false,

      mollieLink: '',
    }
  },
  computed: {
    ...mapState(['categoryData','commitments','categoriesAll','offers','submitData','currentOffer','controlLink','ip','detailsEntered','currentSizeData','travelCosts'])
  },   
  methods: {
    ...mapMutations(['changeCheckoutSubmit','changeCheckoutData','editSize','changeSubmitData','editCategory','changeLink','changeDetailsEntered','changeCurrentSizeData']),
    calculateDiscountPrice(price,commitment){
      if (commitment < 3) 
        return price;
      else if (commitment < 6)
        return Math.round(price * 0.95)
      else if (commitment < 12)
        return Math.round(price * 0.90)
      else if (commitment >= 12)
        return Math.round(price * 0.75)   

    },
    calculateDiscount(commitment){
      let price = this.currentOffer.price
    if (commitment < 3) 
        return price;
      else if (commitment < 6)
        return Math.round(price * 0.95)
      else if (commitment < 12)
        return Math.round(price * 0.90)
      else if (commitment >= 12)
        return Math.round(price * 0.75)     
    },
    changeKlant(){
     if(this.klantBox)
      this.klantType='b2b'
     else{
      this.klantType='b2c'
      this.companyName=''
     } 
    },
    chooseBasic(){
      this.checkSPone=true
      this.checkSPtwo=false
      this.changeSubmitData({item:'plan',new:'Doe het zelf - basic service'})
      this.changeSubmitData({item:'planPrice',new:0})
    },
    choosePremium(){
      this.checkSPone=false
      this.checkSPtwo=true
      this.changeSubmitData({item:'plan',new:'Do it for you - permium service'})
      this.changeSubmitData({item:'planPrice',new:this.currentOffer.premium})
    },
    selectPack(plan){
      if (plan=="Doe het zelf - basic service")
       this.chooseBasic()
      else
       this.choosePremium() 
    },
    selectCommitment(period){
      this.selectedCommitment = period
      this.changeSubmitData({item:'commitment',new:this.selectedCommitment})
      this.changeTravelCosts()

    },
    async selectSize(size){
     this.selectedSize=size
     this.editSize(size)
     this.changeSubmitData({item:'storage_size',new:this.selectedSize})
     if (this.checkSPtwo)
      this.choosePremium()
     else
      this.chooseBasic()
     
     this.editSize(size)

      await axios.get(`https://api-production.inboxstorage.eu/api/v1/control/size/getpost/${size}`).then((response)=>{     
          let data = response.data[0]  
          this.changeCurrentSizeData({item:'size',new:size})
          this.changeCurrentSizeData({item:'lineOne',new:data.lineOne})
          this.changeCurrentSizeData({item:'lineTwo',new:data.lineTwo})
          this.changeCurrentSizeData({item:'lineThree',new:data.lineThree})
          this.changeCurrentSizeData({item:'lineFour',new:data.lineFour})
          this.changeCurrentSizeData({item:'paragraphOne',new:data.body})
          this.changeCurrentSizeData({item:'paragraphTwo',new:data.bodyMin})                   
        }).catch(error => {
          
          console.log(error)
        });
       
    },
    changeTravelCosts(){
      console.log(this.travelCost)
      if(this.selectedCommitment == 1)
       this.travelTotal = this.travelCosts[this.travelCost].one
      if(this.selectedCommitment == 3)
       this.travelTotal = this.travelCosts[this.travelCost].three
      if(this.selectedCommitment == 6)
       this.travelTotal = this.travelCosts[this.travelCost].six
      if(this.selectedCommitment == 12)
       this.travelTotal = this.travelCosts[this.travelCost].twelve   

       

    },
    getDayName(dateStr, locale){
      var date = new Date(dateStr);
      return date.toLocaleDateString(locale, { weekday: 'long' });        
    },
    getMonthName(dateStr, locale){
      var date = new Date(dateStr);
      return date.toLocaleDateString(locale, { month: 'long' });        
    },
    getDay(dateStr){
      var date = new Date(dateStr);
      return date.getDate();        
    },
    getPrefTime(moment){
      if(moment==0)
        return "08:00 - 19:00";
      if(moment==1)
        return "08:00 - 12:00";
      if(moment==2)
        return "12:00 - 16:00";
      if(moment==3)
        return "08:00 - 10:00";
      if(moment==4)
        return "Weekend";
    },
    sevenDays(){
      const date = new Date();
      date.setDate(date.getDate() + 7);
      var formatted_date = date.toJSON().slice(0,10);
      return formatted_date
    },
    setPrefMoment(moment){
      if(moment==0){
        this.changeSubmitData({item:'prefMoment',new:'Dagplanning'})
        this.changeSubmitData({item:'prefMomentPrice',new:0})
      }  
      if(moment==1){
        this.changeSubmitData({item:'prefMoment',new:'Ochtendvak'})
        this.changeSubmitData({item:'prefMomentPrice',new:20})
      }  
      if(moment==2){
        this.changeSubmitData({item:'prefMoment',new:'Middagvak'})
        this.changeSubmitData({item:'prefMomentPrice',new:20})
      }  
      if(moment==3){
        this.changeSubmitData({item:'prefMoment',new:'DagStart'})
        this.changeSubmitData({item:'prefMomentPrice',new:35})
      }  
      if(moment==4){
        this.changeSubmitData({item:'prefMoment',new:'Weekend'})
        this.changeSubmitData({item:'prefMomentPrice',new:50})
      }            
    },
    scrollTo(id){
        
      //document.getElementById(id).scrollIntoView();
      const yOffset = -300; 
      const element = document.getElementById(id);
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({top: y, behavior: 'smooth'});  
      }, 


    async submit(){
      this.finError = ""
      this.phoneError = ""
      this.ophalError = ""
      this.nameError = ""
      this.lnameError = ""
      this.emailError = ""
      this.zipError = ""
      this.cityError = ""
      if(!this.phone)
        this.phoneError = "Vul je telefoonnummer in"

      if(!this.address)
        this.ophalError = "Address is required"

      if(!this.fullName)
        this.nameError = "Vul je naam in"
      
      if(!this.lname)
        this.lnameError = "Vul je achternaam in"

      if(!this.email)
        this.emailError = "Vul je email in"
      
      if(!this.zip)
        this.zipError = "Vul je postcode in"
      
      if(!this.city)
        this.cityError = "Vul je woonplaats in"

      if ( this.phoneError || this.ophalError || this.nameError || this.lnameError  || this.emailError || this.zipError || this.cityError){ 
       this.scrollTo(111)
       return; 
      }

      if(!this.agreeOne || !this.agreeTwo || !this.agreeThree){
        this.finError = "Vul alle velden in om de reservering compleet te maken"
        return;
      } 
      
      if (this.klantType == 'b2b' && !this.companyName){
        this.finError = "Company name required for Business client type"
        return;
      }
      this.changeSubmitData({item:'phone_number',new:this.phone})
       this.changeSubmitData({item:'oldPhone',new:this.phone})
      this.animation=true

        
       

        //HS STUFF
        let hubName = this.fullName
        let hubLname = this.lname
        let hubMail = this.email
        let hubPhone = this.phone
        let hubZip = this.zip
        let hubCity = this.city
        let hubCommitment = this.submitData.commitment
        let hubSize = this.submitData.storage_size
        let hubWhen = this.submitData.wanneer_opslagruimte_nodig
        let hubAddress = this.address
        let hubServiceType = this.submitData.plan
        let hubserviceplanprice = this.submitData.planPrice
        
        let hubDatum = this.pickupDate
        let hubMoment = this.prefMoment
        let hubCtype = this.klantType
        let hubBedrif = this.companyName

        let hubPrice = this.calculateDiscount(hubCommitment)
        let hubLink = this.link
        
        
        let hubQuotePriceOne = this.calculateDiscount(1)
        let hubQuotePriceTwo = this.calculateDiscount(3)
        let hubQuotePriceThree = this.calculateDiscount(6)
        let hubQuotePriceFour = this.calculateDiscount(12)
        let hubSquare_meters = this.currentOffer.sizeSquare *1
        let hubBasic = this.travel
        let hubPremium = (this.currentOffer.premium *1 + (this.travel/1.4*1.9)).toFixed(2)
        let hubspotFields = [
            
            {
                'name' : 'firstname',
                'value' : hubName,
            },
            {
                'name' : 'lastname',
                'value' : hubLname,
            },
            {
                'name' : 'email',
                'value' : hubMail,
            },
            {
                'name' : 'zip',
                'value' : hubZip,
            },
            
            {
                'name' : 'aantal_kuub',
                'value' : hubSize,
            },
            {
                'name' : 'when_storage_required02',
                'value' : hubWhen,
            },
            {
                'name' : 'city',
                'value' : hubCity,
            },
            {
                'name' : 'address',
                'value' : hubAddress,
            },
            {
                'name' : 'serviceType',
                'value' : hubServiceType,
            },
            {
                'name' : 'serviceplanprice',
                'value' : hubserviceplanprice,
            },

            {
                'name' : 'travelCosts',
                'value' : this.travelTotal,
            },            
            
            {
                'name' : 'phone',
                'value' : hubPhone,
            },
            {
                'name' : 'commitment',
                'value' : hubCommitment,
            },          
            {
                'name' : 'pref_date',
                'value' : hubDatum,
            },
            {
                'name' : 'voorkeursmoment',
                'value' : hubMoment,
            },
            {
                'name' : 'klanttype',
                'value' : hubCtype,
            },
            {
                'name' : 'company',
                'value' : hubBedrif,
            },
            
        ];
        let data = {}
        data['context']={
          'pageUri': 'https://inboxstorage.eu/commitment',
          'pageName': 'Commitment',
          
        }
        data['fields']=hubspotFields
        if(!this.disableHubspot){
          axios.post('https://api.hsforms.com/submissions/v3/integration/submit/1979474/2b4d8223-0fc8-4431-9495-29d330ab1cf1',data)
          .then((response)=>{     
            let res = response.data    
            //this.$router.push({path: '/thankyou'})
            this.animation = false
            this.changeDetailsEntered(2)
            
            
            
          }).catch(error => {
            console.log(error)
          });
        }
        await axios.get('https://shop.inboxstorage.eu/api/onetimepayment').then((response)=>{       
       
        
        //console.log(response.data)
        //window.location.href = response.data.link
        //this.$router.push({path: response.data.link})

        this.mollieLink = response.data.link
        this.cart=3
        
        
             
        }).catch(error => {
          this.ICError = error
          this.animation = false
          console.log(error)
        });
        //END HS STUFF

    },//END submit()
    getCommitmentTitle(commitment){
      if(commitment==1)
        return "1+ maand";
      if(commitment==3)
        return "3+ maanden";
      if(commitment==6)
        return "6+ maanden";
      if(commitment==12)
        return "12+ maanden";
    },
    getPlan(){
      return this.submitData.plan
    },
    getPlanPrice(){
      return this.submitData.planPrice
    },
    getTotalES(){
      return this.submitData.totalES
    },
    getESPrice(){
      return this.submitData.totalESPrice
    },
    getPrefMoment(){
     return this.submitData.prefMoment
    },
    getPrefMomentPrice(){
      return this.submitData.prefMomentPrice
    },
    getPrefDate(){
      return this.submitData.prefDate
    },
  },
  created() {
    this.pickupDate = this.sevenDays()
    this.changeSubmitData({item:'prefDate',new:this.pickupDate})
   
  }
}
</script>